export default __webpack_public_path__ + "static/media/htmlCss.084512ab.PNG";